
import { IrisBase } from '@/models/iris/IrisBase'
import { getDefaultRsyncEnable, IRsyncEnable } from './IRsyncEnable'
import { getDefaultRsyncRemote, IRsyncRemote } from './IRsyncRemote'

export interface IRsyncConfig extends IrisBase {
    EnabledMOD:IRsyncEnable
    RSync_remote:IRsyncRemote
} 

export const getDefaultRsyncConfig = ():IRsyncConfig => {
    return {        
        EnabledMOD:getDefaultRsyncEnable(),
        RSync_remote:getDefaultRsyncRemote()
    }
} 